<script lang="ts">
  import { onMount } from 'svelte';
  import { dashboardStore } from '@entities/dashboard/store.svelte';
  import { navigate } from '@shared/router/navigation';

  onMount(() => {
    void dashboardStore.load();
  });

  function go(ev: MouseEvent, path: string) {
    ev.preventDefault();
    navigate(path);
  }
</script>

<h2>ダッシュボード</h2>

{#if dashboardStore.loading && dashboardStore.data === null}
  <p class="muted">読み込み中…</p>
{:else if dashboardStore.error}
  <div class="error">{dashboardStore.error}</div>
{:else if dashboardStore.data}
  {@const k = dashboardStore.data}
  <div class="kpi">
    <div class="card">
      <div class="label">法律事務所</div>
      <div class="value">{k.firm_count.toLocaleString()}</div>
    </div>
    <div class="card">
      <div class="label">営業除外</div>
      <div class="value">{k.competitor_firm_count.toLocaleString()}</div>
    </div>
    <div class="card">
      <div class="label">弁護士</div>
      <div class="value">{k.lawyer_count.toLocaleString()}</div>
    </div>
    <div class="card">
      <div class="label">進行中商談</div>
      <div class="value">{k.open_opportunity_count.toLocaleString()}</div>
    </div>
    <div class="card">
      <div class="label">未対応レコメンド</div>
      <div class="value">{k.pending_recommendation_count.toLocaleString()}</div>
    </div>
    <div class="card">
      <div class="label">提供中のソリューション</div>
      <div class="value">{k.product_count.toLocaleString()}</div>
    </div>
  </div>

  <div class="panel" style="margin-top: 16px;">
    <h3 style="margin-top: 0;">クイックリンク</h3>
    <ul>
      <li><a href="/firms" onclick={(ev) => go(ev, '/firms')}>法律事務所一覧</a></li>
      <li><a href="/lawyers" onclick={(ev) => go(ev, '/lawyers')}>弁護士一覧</a></li>
      <li><a href="/products" onclick={(ev) => go(ev, '/products')}>ソリューション一覧</a></li>
    </ul>
  </div>
{/if}
